import { buildUrlWithParams } from 'helpers/url_helper';
import { HttpClient } from './apiClient';
import { ApiResponse } from './types/auth.types';

interface FindAllParams {
  skip?: number;
  take?: number;
  [key: string]: any;
}

export function crudFactory<T, CreateDto = Partial<T>, UpdateDto = Partial<T>>(endpoint: string) {
  return {
    findAll(params?: FindAllParams): Promise<ApiResponse<T[]>> {
      const url = buildUrlWithParams(endpoint, params);

      return HttpClient.get<ApiResponse<T[]>>(url, { params });
    },

    findOne(queryParams?: Record<string, any>): Promise<ApiResponse<T>> {
      const url = buildUrlWithParams(endpoint, queryParams);
      return HttpClient.get<ApiResponse<T>>(url);
    },

    create(data: CreateDto): Promise<ApiResponse<T>> {
      return HttpClient.post<ApiResponse<T>>(endpoint, data);
    },

    update(id: string | number, data: UpdateDto, queryParams?: Record<string, any>): Promise<T> {
      const url = buildUrlWithParams(`${endpoint}/${id}`, queryParams);
      return HttpClient.put<T>(url, data);
    },

    updatePatch(data: UpdateDto, queryParams?: Record<string, any>): Promise<ApiResponse<T>> {
      const url = buildUrlWithParams(endpoint, queryParams);
      return HttpClient.patch<ApiResponse<T>>(url, data);
    },

    remove(id?: string | number, queryParams?: Record<string, any>): Promise<T> {
      const url = buildUrlWithParams(id ? `${endpoint}/${id}` : endpoint, queryParams);
      return HttpClient.delete<T>(url);
    },
  };
}
